var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1672 10.6972C23.1672 9.58724 22.2672 8.69724 21.1672 8.69724H14.8472L15.8072 4.12724C15.8272 4.02724 15.8372 3.91724 15.8372 3.80724C15.8372 3.39724 15.6672 3.01724 15.3972 2.74724L14.3372 1.69724L7.75724 8.27724C7.38724 8.64724 7.16724 9.14724 7.16724 9.69724V19.6972C7.16724 20.2277 7.37795 20.7364 7.75302 21.1114C8.1281 21.4865 8.6368 21.6972 9.16724 21.6972H18.1672C18.9972 21.6972 19.7072 21.1972 20.0072 20.4772L23.0272 13.4272C23.1172 13.1972 23.1672 12.9572 23.1672 12.6972V10.6972ZM1.16724 21.6972H5.16724V9.69724H1.16724V21.6972Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.dcf0ce9971e2c3edae8cea6bf97c1c35.svg";
export { ForwardRef as ReactComponent };